// ============================================
// API SERVICE
// ============================================

import { createApiClient, ApiClient } from '@crew-at-sea/api-client';
import { useAuthStore } from '@/store/auth';

let apiClient: ApiClient | null = null;

function readStoredToken(key: 'accessToken' | 'refreshToken'): string | null {
  try {
    const stored = localStorage.getItem('company-auth-storage');
    if (stored) {
      return JSON.parse(stored)?.state?.[key] || null;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
}

export function initializeApiClient(): void {
  apiClient = createApiClient({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1',
    timeout: 10000,
    
    // Read tokens from localStorage first: refresh tokens rotate on every use, so when
    // several tabs are open another tab may already have replaced them. The persisted
    // copy is always the newest; the in-memory store is only a fallback.
    getAccessToken: () => readStoredToken('accessToken') || useAuthStore.getState().accessToken,

    getRefreshToken: () => readStoredToken('refreshToken') || useAuthStore.getState().refreshToken,
    
    onAccessTokenRefreshed: (accessToken, refreshToken) => {
      useAuthStore.getState().setTokens(accessToken, refreshToken);
    },
    
    onUnauthorized: () => {
      useAuthStore.getState().logout();
      window.location.href = '/login';
    },
    
    onError: (error) => {
      console.error('API Error:', error);
    },
  });
}

export function getApi(): ApiClient {
  if (!apiClient) {
    initializeApiClient();
  }
  return apiClient!;
}

// Re-export API endpoints
export {
  authApi,
  companiesApi,
  jobsApi,
  applicationsApi,
  certificatesApi,
  reviewsApi,
  matchingApi,
  favoritesApi,
  notificationsApi,
  usersApi,
  analyticsApi,
  commonApi,
  supportApi,
  paymentsApi,
} from '@crew-at-sea/api-client';
